<template>
  <div class="container-fluid machine-selector-filter-box">
    <div id="modal-filter" class="modal">
      <div class="modal-wrapper">
        <div class="modal-loader">
          <img src="/typo3conf/ext/ccm_pim_frontend/Resources/Public/Icons/pre_loader.svg">
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-3" v-for="filter in selectFilter" :key="filter.name">
          <select-filter :property="filter.property" :title="filter.title"></select-filter>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3" v-for="filter in slideFilter" :key="filter.name">
          <slide-filter :property="filter.property"></slide-filter>
        </div>
      </div>
      <div class="row">
        <div class="col-12" v-if="startCounting">
          <a @click="fetchMachines" class="cta-button" href="#">{{ctaButton}} ({{resultCount}})</a>
        </div>
      </div>
    </div>
  </div>
  <div v-for="product in results" :key="product.name" class="container machine-selector-result-box">
      <result :product="product" ></result>
  </div>

</template>

<script>
import SelectFilter from "./Components/SelectFilter";
import SlideFilter from "./Components/SlideFilter";
import Result from "./Components/Result";

export default {
  name: 'App',
  components: {
    SelectFilter,SlideFilter,Result
  },
  data:function (){
    return {
      showButton:false,
    }
  },
  methods:{
      fetchMachines(event){
        event.preventDefault();
        this.$store.dispatch('fetchResults',this.$store.getters.selectedValues);
      }
  },
  computed:{
    filters(){
      return this.$store.getters.filters;
    },
    slideFilter(){
      return this.$store.getters.filters.filter(filter => filter.type==='slide');
    },
    selectFilter(){
      return this.$store.getters.filters.filter(filter => filter.type==='select');
    },
    startCounting(){
      return this.$store.getters.startCounting;
    },
    resultCount(){
      return this.$store.getters.resultCount;
    },
    results(){
      return this.$store.getters.results;
    },
    ctaButton(){
      return this.$store.getters.ctaButton;
    }
  },
  beforeMount() {
    this.$store.dispatch('fetchFilterValues');

  }
}
</script>
